import React from 'react';
import { Box, BoxProps, withStyles } from '@material-ui/core';
import cn from 'classnames';
import FsBody from 'ui-elements/typography/FsBody';
import FsBodyBold from 'ui-elements/typography/FsBodyBold';

interface DataColProps extends BoxProps {
  isLast?: boolean;
}

export const WrapperBox = withStyles(({ breakpoints }) => ({
  root: {
    [breakpoints.up('sm')]: {
      display: 'flex',
      justifyContent: 'space-between',
    },
  },
}))(Box);

export const DataCol = withStyles(({ palette, spacing, breakpoints }) => ({
  root: {
    width: '100%',
    borderBottom: `1px solid ${palette.grey[200]}`,
    marginBottom: spacing(2),
    paddingBottom: spacing(2),
    [breakpoints.up('sm')]: {
      width: '33.333%',
      borderRight: `1px solid ${palette.grey[200]}`,
      marginRight: spacing(2),
      paddingRight: spacing(2),
      borderBottom: 0,
      marginBottom: 0,
      paddingBottom: 0,
    },
    [breakpoints.up('md')]: {
      marginRight: spacing(4),
      paddingRight: spacing(4),
    },
    '&.isLast': {
      borderRight: 0,
      marginRight: 0,
      paddingRight: 0,
      borderBottom: 0,
      marginBottom: 0,
      paddingBottom: 0,
    },
  },
}))(({ isLast = false, ...otherProps }: DataColProps) => (
  <Box {...otherProps} className={cn({ isLast })} />
));

export const Caption = withStyles(({ spacing }) => ({
  root: {
    marginBottom: spacing(1),
    '&:after': {
      content: '":"',
    },
  },
}))(FsBody);

export const Value = withStyles(({ spacing }) => ({
  root: {
    marginBottom: spacing(2),
  },
}))(FsBodyBold);
